export const INTENT_MAX = 200;
/** Matches apps/api/src/modules/web-chat/loop.ts `MAX_MESSAGE_CHARS`. */
export const MESSAGE_MAX = 32_768;

export const VERTICALS = [
  {
    label: "Photographer",
    intent: "I'm a photographer. I need a site for my work.",
    name: "Ellis Studio",
    kicker: "Photography",
    title: "Work that feels like you.",
    detail: "Portraits, events, and a simple way to book.",
    now: "Bookings open",
    wash: "radial-gradient(circle at 72% 30%, rgba(210,196,176,0.85), transparent 28%), linear-gradient(135deg, #f4efe8 8%, #e6ddd2 52%, #efe8e0 100%)",
  },
  {
    label: "Restaurant",
    intent: "We run a restaurant and need a simple site with the menu.",
    name: "Hearth",
    kicker: "Kitchen",
    title: "Tonight, made clearly.",
    detail: "Menu, hours, and a way to get a table.",
    now: "Dinner from 5",
    wash: "radial-gradient(circle at 72% 30%, rgba(174,209,205,0.8), transparent 28%), linear-gradient(135deg, #edf4f0 8%, #dcebe7 52%, #efeef5 100%)",
  },
  {
    label: "Musician",
    intent: "We're a band. Put up our shows and a way to get in touch.",
    name: "Northline",
    kicker: "Music",
    title: "Good work, clearly presented.",
    detail: "Shows, a listen, and how to reach you.",
    now: "June dates",
    wash: "radial-gradient(circle at 72% 30%, rgba(184,181,224,0.62), transparent 24%), linear-gradient(135deg, #eef0f5 8%, #e4e8f0 52%, #edf4f0 100%)",
  },
] as const;

export function intentFromMessage(message: string): string | undefined {
  const intent = message.trim().slice(0, INTENT_MAX);
  return intent.length > 0 ? intent : undefined;
}
